export const CDR_REQUESTED_ACTION = {
  DELETION: "deletion",
  REASSIGNMENT: "reassignment",
} as const;

export type CdrRequestedAction =
  (typeof CDR_REQUESTED_ACTION)[keyof typeof CDR_REQUESTED_ACTION];

export const CDR_EXECUTION_MODE = {
  FORM: "form",
  READONLY: "readonly",
} as const;

export type CdrExecutionMode =
  (typeof CDR_EXECUTION_MODE)[keyof typeof CDR_EXECUTION_MODE];

export const CDR_SCOPE_TYPE = {
  PATIENT: "patient",
  EXAMINATION: "examination",
  WOUND_CASE: "wound_case",
  SUB_EXAMINATION: "sub_examination",
} as const;

export type CdrFlaggableScopeType =
  | typeof CDR_SCOPE_TYPE.PATIENT
  | typeof CDR_SCOPE_TYPE.EXAMINATION;

export const CDR_ACK_STATUS = {
  INFORMED: "informed",
  NOT_INFORMED: "not_informed",
} as const;

export type CdrAckStatus = (typeof CDR_ACK_STATUS)[keyof typeof CDR_ACK_STATUS];
